import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, of } from 'rxjs';
import { map, first, catchError } from 'rxjs/operators';
import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';

@Injectable({
  providedIn: 'root'
})
export class CitiesService {
  private cities = new ReplaySubject<any>(1);
  private citiesPicker = new ReplaySubject<any>(1);

  constructor(private cms: ACResourceService) { }

  public updateCities = (params: any) => {
    var path = `/facility/city-list`
    return this.cms.request('GET', path, params).pipe(
      first(),
      map(data => {
        this.cities.next(data)
        return data
      })
    )
  }

  public getCities = (): Observable<any> => {
    return this.cities.asObservable()
  }

  public updateCitiesPicker = (params: any) => {
    var path = `/facility/city-list`
    return this.cms.request('GET', path, params).pipe(
      first(),
      map(body => {
        this.citiesPicker.next(body.data)
        return body.data
      }),
      catchError(err => {
        this.citiesPicker.next([])
        return of([])
      })
    )
  }

  public getCitiesPicker = (): Observable<any> => {
    return this.citiesPicker.asObservable()
  }

}
